import { useState } from 'react';
import { CalendarIcon } from '@radix-ui/react-icons';
import { format } from 'date-fns';
import { ChevronDown } from 'lucide-react';

import { cn } from '@/utils';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover';

// const getDisabledDates = (type) => {
//   switch (type) {
//     case 'past':
//       return (date) => date < new Date();
//     case 'future':
//       return (date) => date > new Date();
//     case 'all':
//     default:
//       return undefined;
//   }
// };

const SelectDate = ({
  value,
  onChange
  // disabled
}) => {
  const [month, setMonth] = useState(new Date());
  const [isSelectDateOpen, setIsSelectDateOpen] = useState(false);
  const [isMonthPopoverOpen, setIsMonthPopoverOpen] = useState(false);
  const [isYearPopoverOpen, setIsYearPopoverOpen] = useState(false);

  const years = Array.from(
    { length: 66 },
    (_, i) => new Date().getFullYear() - 65 + i
  );
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  return (
    <Popover open={isSelectDateOpen} onOpenChange={setIsSelectDateOpen}>
      <PopoverTrigger asChild>
        <Button
          variant={'outline'}
          className={cn(
            'w-full pl-3 text-left font-normal flex items-center justify-start',
            !value && 'text-muted-foreground'
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4 flex-shrink-0" />
          <span className="flex-grow text-left truncate">
            {value ? format(value, 'MMM d, yyyy') : 'Pick a date'}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <div className="flex gap-2 p-3">
          <Popover
            open={isMonthPopoverOpen}
            onOpenChange={setIsMonthPopoverOpen}
          >
            <PopoverTrigger asChild>
              <Button variant="outline" className="flex gap-2">
                {format(month, 'MMMM')}
                <ChevronDown />
              </Button>
            </PopoverTrigger>
            <PopoverContent
              className="w-[110px] p-0"
              side="bottom"
              align="start"
            >
              <div className="flex flex-col h-[200px] overflow-y-auto">
                {months.map((monthName, index) => (
                  <Button
                    key={monthName}
                    variant="ghost"
                    className="justify-start"
                    onClick={() => {
                      setMonth(new Date(month.getFullYear(), index));
                      setIsMonthPopoverOpen(false);
                    }}
                  >
                    {monthName}
                  </Button>
                ))}
              </div>
            </PopoverContent>
          </Popover>

          <Popover open={isYearPopoverOpen} onOpenChange={setIsYearPopoverOpen}>
            <PopoverTrigger asChild>
              <Button variant="outline" className="flex gap-2">
                {format(month, 'yyyy')}
                <ChevronDown />
              </Button>
            </PopoverTrigger>
            <PopoverContent
              className="w-[90px] p-0"
              side="bottom"
              align="start"
            >
              <div className="flex flex-col h-[200px] overflow-y-auto">
                {years.map((year) => (
                  <Button
                    key={year}
                    variant="ghost"
                    className="justify-start"
                    onClick={() => {
                      setMonth(new Date(year, month.getMonth()));
                      setIsYearPopoverOpen(false);
                    }}
                  >
                    {year}
                  </Button>
                ))}
              </div>
            </PopoverContent>
          </Popover>
        </div>
        <Calendar
          mode="single"
          selected={value}
          onSelect={(date) => {
            onChange(date ? date.toISOString() : date);
            setIsSelectDateOpen(false);
          }}
          month={month}
          onMonthChange={setMonth}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export default SelectDate;
